import { useMemo, useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { zoneTags, zones } from "@/mocks/home";

export default function ZonesSection() {
  const [activeTag, setActiveTag] = useState("all");

  const visibleZones = useMemo(() => {
    if (activeTag === "all") return zones;
    return zones.filter((zone) => zone.tag === activeTag);
  }, [activeTag]);

  return (
    <section id="content-zones" className="scroll-mt-28 py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <SectionHeading
          eyebrow="内容分区"
          title="平台上有哪些内容可以看"
          desc="进入后通常按以下分区组织内容，先了解栏目结构，找片会更省时间。点击标签可快速筛选。"
        />

        <div className="mt-8 flex flex-wrap gap-2">
          {zoneTags.map((tag) => {
            const active = tag.id === activeTag;
            return (
              <button
                key={tag.id}
                type="button"
                onClick={() => setActiveTag(tag.id)}
                aria-pressed={active}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap border ${
                  active
                    ? "bg-accent-500 text-background-50 border-accent-500"
                    : "bg-background-50 text-foreground-700 border-background-300 hover:border-accent-300 hover:text-accent-700"
                }`}
              >
                {tag.label}
              </button>
            );
          })}
        </div>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {visibleZones.map((zone) => (
            <article
              key={zone.id}
              className="flex flex-col p-5 rounded-lg border border-background-200 bg-background-50"
            >
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className={`${zone.icon} text-lg`} aria-hidden="true" />
                </span>
                <div>
                  <h3 className="font-heading font-bold text-base text-foreground-950">{zone.title}</h3>
                  <span className="text-xs text-foreground-500">{zone.tagLabel}</span>
                </div>
              </div>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed flex-1">{zone.desc}</p>
              <ul className="mt-4 flex flex-wrap gap-2">
                {zone.points.map((point) => (
                  <li
                    key={point}
                    className="text-xs text-secondary-900 bg-secondary-100/80 rounded-full px-2.5 py-1"
                  >
                    {point}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}